/**
 * Stingers: short cues played once over the music (which ducks under them), each with an ending of
 * its own. A quest completed, a new rank (realm stage) reached, a boss defeated, and death.
 */
import { registerTrack } from '../registry';

registerTrack({
  id: 'quest',
  order: 19,
  title: 'ภารกิจสำเร็จ',
  mood: 'สดใส ภูมิใจ',
  use: 'สติงเกอร์: ทำภารกิจสำเร็จ',
  key: 'D',
  mode: 'gong',
  bpm: 96,
  meter: 4,
  seed: 1919,
  humanize: 0.2,
  parts: {
    zheng: { inst: 'zheng', pan: 0.1, reverb: 0.4 },
    bass: { inst: 'zheng', gain: 0.55, pan: -0.2, reverb: 0.35 },
    bells: { inst: 'perc', gain: 0.25, pan: 0.3, reverb: 0.5 },
  },
  sections: {
    S: {
      bars: 3,
      rit: 0.8,
      parts: {
        zheng: `@f 5_ 6_ 1'_ 2'_ 3' 5'g | 6'*- 5'*- | 1''*---`,
        bass: `@mf 1,&5,--- | 6,,&3,--- | 1,&5,---`,
        bells: `0--- | h--- | b---`,
      },
    },
  },
  form: ['S'],
  loop: false,
});

registerTrack({
  id: 'rankup',
  order: 20,
  title: 'ทะลวงขั้นพลัง',
  mood: 'ยิ่งใหญ่ เปิดกว้าง',
  use: 'สติงเกอร์: ขั้นพลังฝีมือ (境界) สูงขึ้น',
  key: 'D',
  mode: 'gong',
  bpm: 84,
  meter: 4,
  seed: 2020,
  humanize: 0.2,
  parts: {
    zheng: { inst: 'zheng', pan: 0.1, reverb: 0.45 },
    dizi: { inst: 'dizi', pan: -0.15, reverb: 0.45 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.5 },
    gong: { inst: 'perc', gain: 0.4, reverb: 0.5 },
  },
  sections: {
    S: {
      bars: 4,
      rit: 0.8,
      parts: {
        gong: `G--- | 0--- | h--- | b---`,
        zheng: `@f 1'g- 0- | 3'_ 5'_ 6'_ 5'_ 3'%- | 0--- | 1'&5'g---`,
        dizi: `0--- | 0--- | @f 5. 6_ 1' 2' | 1'---`,
        pad: `@mf 1,&5,--- | 1,&5,--- | 6,,&3,--- | 1,&5,---`,
      },
    },
  },
  form: ['S'],
  loop: false,
});

registerTrack({
  id: 'victory',
  order: 21,
  title: 'ชัยชนะ',
  mood: 'ฮึกเหิม เฉลิมฉลอง',
  use: 'สติงเกอร์: ปราบบอสสำเร็จ',
  key: 'D',
  mode: 'gong',
  bpm: 120,
  meter: 4,
  seed: 2121,
  humanize: 0.15,
  parts: {
    zheng: { inst: 'zheng', pan: 0.1, reverb: 0.35 },
    pipa: { inst: 'pipa', gain: 0.8, pan: -0.2, reverb: 0.3 },
    drums: { inst: 'perc', gain: 0.5, reverb: 0.3 },
  },
  sections: {
    S: {
      bars: 3,
      rit: 0.85,
      parts: {
        drums: `D_ D_ d_ d_ g&D D | D_ d_ d_ D_ D&c- | G---`,
        zheng: `@f 1_ 2_ 3_ 5_ 6 1' | 2'_ 3'_ 5'_ 6'_ 5'g- | 1''*---`,
        pipa: `@f 1&5!- 6,&3 1&5 | 2&6!- 1&5- | 1&5%---`,
      },
    },
  },
  form: ['S'],
  loop: false,
});

registerTrack({
  id: 'death',
  order: 22,
  title: 'ดับสูญ',
  mood: 'เศร้า ทิ้งดิ่ง',
  use: 'สติงเกอร์: ตัวละครตาย',
  key: 'D',
  mode: 'yu',
  bpm: 50,
  meter: 4,
  seed: 2222,
  humanize: 0.3,
  parts: {
    qin: { inst: 'qin', pan: 0.05, reverb: 0.6 },
    xiao: { inst: 'xiao', gain: 0.85, pan: -0.2, reverb: 0.6 },
    pad: { inst: 'pad', gain: 0.9, reverb: 0.6 },
    gong: { inst: 'perc', gain: 0.4, reverb: 0.6 },
  },
  sections: {
    S: {
      bars: 2,
      rit: 0.85,
      parts: {
        gong: `G--- | 0---`,
        qin: `@f 6,\\- 3,\\- | 6,,~---`,
        xiao: `@p 0- 3\\- | 0---`,
        pad: `@mp 6,,&3,--- | 6,,&3,---`,
      },
    },
  },
  form: ['S'],
  loop: false,
});
